import { mount } from '../dom-lifecycle';

// Moves the content of a <template data-teleport="<selector>"> into the target (defaults to body).
// Parsing inside <template> is inert, so a nested <form> survives the parser; relocating it out of
// the page form makes it valid. dom-lifecycle's MutationObserver auto-mounts the teleported content.
mount('template[data-teleport]', function (el) {
    const target = document.querySelector(el.dataset.teleport) || document.body;
    target.appendChild(el.content);
});
